'use strict';

/**
 * Friendly display labels for OAuth provider keys (google, github, ...).
 *
 * Shared between the full sign-in screen (PictView-Auth) and the in-place
 * re-auth modal (PictView-ReAuth) so a newly configured identity provider
 * reads the same way in both places without either file guessing at it.
 */

const _PROVIDER_LABELS =
{
	'google': 'Google',
	'github': 'GitHub',
	'microsoft': 'Microsoft'
};

// The provider's short name, e.g. "Google", "GitHub", or a capitalized
// fallback for a provider this map does not know about yet.
function labelForProvider(pProviderName)
{
	let tmpKey = String(pProviderName || '').toLowerCase();
	if (_PROVIDER_LABELS[tmpKey]) { return _PROVIDER_LABELS[tmpKey]; }
	return pProviderName ? (String(pProviderName).charAt(0).toUpperCase() + String(pProviderName).slice(1)) : 'SSO';
}

module.exports = { labelForProvider: labelForProvider };
